import { render, staticRenderFns } from "./ResidenceIllustration.vue?vue&type=template&id=3a792c76&"
import script from "./ResidenceIllustration.vue?vue&type=script&lang=js&"
export * from "./ResidenceIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a792c76')) {
      api.createRecord('3a792c76', component.options)
    } else {
      api.reload('3a792c76', component.options)
    }
    module.hot.accept("./ResidenceIllustration.vue?vue&type=template&id=3a792c76&", function () {
      api.rerender('3a792c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResidenceIllustration.vue"
export default component.exports